import React from 'react';
import { Dot, MenuContainer } from './MenuComponents';

const Menu = ({ toggler }) => {
  return (
    <MenuContainer onClick={() => toggler()}>
      <Dot />
      <Dot />
      <Dot />
    </MenuContainer>
  );
};

export default Menu;
